import { useMemo, useState } from 'react';
import ImageUploadComponente from '../components/ui/UploadImage/ImageUploadComponente';



export const useUploadImagesGeneric = () => {
  ///* local state -----------
  const [image1, setImage1] = useState<File | null>(null);
  const [image2, setImage2] = useState<File | null>(null);
  const [image3, setImage3] = useState<File | null>(null);
  const [image4, setImage4] = useState<File | null>(null);
  const [image5, setImage5] = useState<File | null>(null);
  const [image6, setImage6] = useState<File | null>(null);

  ///* upload component
  const UploadImageComponent = useMemo(
    () => ImageUploadComponente,
    [image1, image2, image3, image4, image5, image6]
  );

  return {
    UploadImageComponent,

    image1,
    image2,
    image3,
    image4,
    image5,
    image6,
    setImage1,
    setImage2,
    setImage3,
    setImage4,
    setImage5,
    setImage6,
  };
};
